import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation, Trans } from 'react-i18next';
import { useFormik } from 'formik';
import { Element, animateScroll as scroll, scroller } from 'react-scroll';
import { useQuery, useMutation } from 'react-query';
import { ProgressBar, Step } from 'react-step-progress-bar';
import PropTypes from 'prop-types';
import Select from 'react-select';
import DatePicker, { registerLocale } from 'react-datepicker';
import { toast } from 'react-toastify';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-step-progress-bar/styles.css';
import {
  Form,
  FormGroup,
  Label,
  Input,
  CustomInput,
  InputGroup,
  FormText,
  FormFeedback,
  Container,
  Button,
  Col,
  Spinner,
  Card,
  CardBody,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import * as Yup from 'yup';
import clsx from 'clsx';
import { useField } from 'formik';
import styled from 'styled-components';
import InputWithLoader from '../components/InputWithLoader';
import PhoneNumberInput from '../components/PhoneNumberInput';
import HorizontalStepper from '../components/HorizontalStepper';
import Checkbox from '../components/Checkbox';
import useInterval from '../hooks/useInterval';
import useQueryParams from '../hooks/useQuery';
import { getMongoObjectId } from '../utils';
import FormRecoverSent from '../images/public-form/form-recover-snet.svg';

import {
  LegalParticipantSchema,
  IndividualParticipantSchema,
  getParticipantSchema,
} from '../components/ParticipantForm';

import {
  fetchForm,
  answerForm,
  saveUserForm,
  fetchUserForm,
  resendUserFormDocument,
} from '../api/actions/forms';
import { fetcher } from '../api/client';

import Logo from '../images/logo/owl-logo.svg';
import { PublicFormLayout } from './PublicFormHome';
import useFileUpload from '../api/hooks/useFileUpload';

registerLocale('es', es);

function getInitialValues(questions = [], participant = {}) {
  return {
    questions: questions.reduce((obj, question) => {
      obj[question._id] = ''; // question.answers[0]._id
      return obj;
    }, {}),
    variables: participant.variables
      .filter((variable) => variable.type && variable.name)
      .reduce((obj, variable) => {
        if (variable.type === 'fixed' && variable.options?.length) {
          obj[variable._id] = variable.options[0];
        } else if (variable.type === 'date') {
          obj[variable._id] = Date.now();
        } else {
          obj[variable._id] = '';
        }
        return obj;
      }, {}),
    attachments:
      participant.attachments?.reduce((obj, attachment) => {
        obj[attachment._id] = { name: '', url: '' };
        return obj;
      }, {}) || {},
    participant: {
      name: '',
      last_name: '',
      representative: '',
      email: '',
      phone: '',
      label: participant.label,
      obligation: participant.obligation,
    },
  };
}

const initialValues = {
  agendaProperties: {},
  attachments: {
    '610b22c45baed74b05b9c014': '', //{ url: "https://enterprise-test-bucket.s3.amazonaws.com/491c3cb7-e4b9-497b-b5ca-ceb57f0b27de.pdf" },
    '610b22c65baed74b05b9c016': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/d2377e03-5d67-4f64-90ff-79aff2c64c07.pdf',
    },
    '610b43ba5baed74b05ba6c47': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/cf84fe13-5b05-4370-9a37-a99cf16b63ff.pdf',
    },
    '610b43d45baed74b05ba6c7d': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/8eb06df5-5e61-412d-8421-27031c0641a0.pdf',
    },
    '610b22c75baed74b05b9c018': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/0355f08d-a2bc-44cf-a89a-2079aa06a79a.pdf',
    },
    '610b425e5baed74b05ba5c47': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/21a4b1c9-a078-44c0-ba9d-eda8885eb491.pdf',
    },
    '610b426a5baed74b05ba5c4b': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/e0a0a684-f580-4998-9635-d6b7a5720067.pdf',
    },
    '610b25284b19e42cb7368a6c': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/c93b92f6-3850-47e2-8db2-75027449f3be.pdf',
    },
    '610b25334b19e42cb7368a77': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/05d69753-2c72-4de3-ac60-0076b9b4a46b.pdf',
    },
    '610b42795baed74b05ba5cc1': {
      url: 'https://enterprise-test-bucket.s3.amazonaws.com/3a7201ce-845c-4e65-885a-0257bfeafcf8.pdf ',
    },
  },
  participant: {
    email: 'fernando@trato.io',
    label: 'EL CLIENTE',
    last_name: '',
    name: 'Empresa SA DE CV',
    obligation: 'legal',
    phone: '55 5555 1851',
    representative: 'Test',
  },
  questions: {
    '6142710fb618aa33fef6b3a2': '6142710fb618aa33fef6b3a7',
    '6142710fb618aa33fef6b3ac': '6142710fb618aa33fef6b3ad',
    '6142710fb618aa33fef6b3b1': '6142710fb618aa33fef6b3b2',
    '6142710fb618aa33fef6b3c2': '6142710fb618aa33fef6b3c3',
    '6142710fb618aa33fef6b3ca': '6142710fb618aa33fef6b3cb',
    '6142710fb618aa33fef6b3d4': '6142710fb618aa33fef6b423',
  },
  variables: {
    '610b5aac908c8a41a32a10d8': 'Nacional',
    '610b21e37f3575f6fe11ef8a': 'Salma',
    '610b21ee28458e9685c3191b': 'Senador',
    '610b21fe96a5976b5ccc2d59': 'Militar',
    '610b2281a0125df73027fdc0': 'Negocios',
    '610b229119303eab1bab2963': 'A cosas personales',
    '61300eb74303dc9f5a3418fe': '1',
    '61301b0c5851cbd1dc2539a6': 'No lo se',
    '61301b6b972e29fdfb2af8a4': 'Si lo dara',
    '61301b98bd4228df25f8c0f6': '10000',
    '61301b810d02ba1f26e151d2': 'Salario Fijo',
    '61301f617fd147fb17ca6c92': 'Alan',
    '613003b12ab59eef152daa7b': '10,000',
    '613003beaf5332ced441f914': '12',
    '613017c40b6a3ed3d7fc0198': 'Porque si',
    '613017dae82edeba91dadca6': 'Amistad',
    '613017f62ee979ea669df20e': 'Si',
    '613019de3019d6c2a53c0fca': '20000',
    '613020c55f8eb51a054350c1': 'Peter',
    '613023e640be24766d1604d1': 'Morales',
    '613023f799a05b1e89bf6a48': '2019-02-25T06:00:00.000Z',
    '613024ba9397bc8f6b5e91c4': 'Aleman',
    '613024cbdd684e9709ed4039': 'hedf950508',
    '613024dc0fa21c1c45884b1a': 'hedf9505082qa',
    '613025a4ef377f9eed7baff9': '1',
    '613025b5b0b30f4584bc313c': '25',
    '613025c244466b5952d07d8f': 'Alamos',
    '613025d2a16265fa553817d8': '09220',
    '613025ebeb807eeb5ac60068': 'Iztapalapa',
    '613026aae8d8b9a9333b6d64': 'Pfizer SA DE CV DE ES',
    '6130042ca2e9869941610a3e': '4',
    '6130060ccc376c0d58cb7c8d': 'Mexico',
    '6130257d9f886af1dce6ec63': '254123',
    '6130267f51b147a49bcd6e03': 'Gerente',
    '6130268b49fa149e3747902e': '25000',
    '61300416f33fcf519764aca7': '20',
    '61300564efb2164dc5bf914a': 'No Moleste Sr',
    '61302592f7a2eef91621413d': 'Xola Narvarte Poniente',
    '61302603c6015de47c8a8a05': 'Por favor seleccione una colonia.',
    '613026137b25bc8b9d97a8eb': 'Estado de México',
    '613026289acec9799b3fe21b': 'México',
    '6130265346f550b2a7fdc788': 'Comerciante',
    '6130267011e8007bf1146cd3': 'Pfizer',
  },
};

function getSchema(
  questions = [],
  attachments = [],
  pendingVariables = [],
  { validatePhone } = {}
) {
  const allQuestionsAnswers = questions.flatMap((q) => q.answers);

  return Yup.lazy((params) => {
    console.log({ params });
    const currentAnswers = Object.values(params.questions || {});
    const populatedCurrentAnswers = allQuestionsAnswers.filter((a) =>
      currentAnswers.includes(a._id)
    );
    const allCurrentAnswersVariables = populatedCurrentAnswers.flatMap(
      (a) => a.variables
    );

    const { agendaProperties, ...variablesSchema } =
      allCurrentAnswersVariables.reduce((obj, variable) => {
        const variableId =
          variable.type === 'constant'
            ? variable.apiName.replace('.', '-')
            : variable._id;
        if (variable.type === 'fixed' && variable.options?.length) {
          obj[variableId] = Yup.string().required('Required');
        } else if (variable.type === 'date') {
          obj[variableId] = Yup.string();
        } else if (variable.type === 'number') {
          obj[variableId] = Yup.number().required('Required');
        } else {
          obj[variableId] = Yup.string().required('Required');
        }
        return obj;
      }, {});
    console.log({ agendaProperties });

    return Yup.object().shape({
      questions: Yup.object().shape(
        Object.keys(params.questions || {}).reduce((obj, questionKey) => {
          obj[questionKey] = Yup.string();
          return obj;
        }, {})
      ),
      variables: Yup.object().shape({
        ...variablesSchema,
        agendaProperties: Yup.object().shape(agendaProperties),
      }),
      pendingVariables: Yup.object().shape(
        pendingVariables.reduce((obj, variable) => {
          const variableId = variable._id;
          if (variable.type === 'fixed' && variable.options?.length) {
            obj[variableId] = Yup.string().required('Required');
          } else if (variable.type === 'date') {
            obj[variableId] = Yup.string();
          } else {
            obj[variableId] = Yup.string().required('Required');
          }
          return obj;
        }, {})
      ),
      participant: getParticipantSchema({ validatePhone }),
      attachments: Yup.object().shape(
        Object.keys(params.attachments || {}).reduce((obj, attachmentId) => {
          const pAttachment = attachments.find((a) => a._id === attachmentId);
          // console.log({pAttachment, attachments, attachmentId})
          obj[attachmentId] = Yup.object().shape({
            url: pAttachment?.required
              ? Yup.string().required('Required')
              : Yup.string(),
            name: Yup.string(),
          });
          return obj;
        }, {})
      ),
    });
  });
}

const Root = styled.section`
  font-family: 'Lato', sans-serif;
`;
const StyledCard = styled(Card)`
  border-radius: 22px;
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100px;
  height: 100px;
  top: -50px;
  left: 50%;
  background: white;
  overflow: hidden;
  transform: translate(-50%, 0);
  border-radius: 50%;
`;
const Image = styled.img`
  width: auto;
  ${'' /* height: auto; */}
`;
const StyledStep = styled(Step)`
  color: white;
  width: 20px;
  height: 20px;
  font-size: 12px;
  background-color: rgba(211, 211, 211, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.accomplished {
    background-color: rgba(0, 116, 217, 1);
  }
`;

function Stepper({ steps = [], currentStep }) {
  const length = steps.length;
  const percentPerStep = 100 / (length - 1);

  return (
    <ProgressBar
      height={5}
      filledBackground="#f47b33"
      percent={Math.min(percentPerStep * (currentStep - 1) + 1, 100)}
      hasStepZero
    >
      {steps.map((step) => (
        <StyledStep>
          {({ accomplished, index }) => (
            <div
              className={`indexedStep position-relative ${
                accomplished ? 'accomplished pointer' : null
              }`}
              onClick={currentStep > index + 1 ? step.onClick : undefined}
            >
              {currentStep > index + 1 ? (
                <FontAwesomeIcon icon="check-circle" />
              ) : (
                index + 1
              )}
              <div
                className="position-absolute text-black-50 text-center"
                style={{ top: 40 }}
              >
                {step.title}
              </div>
            </div>
          )}
        </StyledStep>
      ))}
    </ProgressBar>
  );
}

function PublicForm() {
  const { t, i18n } = useTranslation('common', { useSuspense: false });
  const history = useHistory();

  const { formId, userFormId } = useParams();
  const [variables, setVariables] = useState();
  const [initialValues, setInitialValues] = useState({});
  const [totalQuestions, setTotalQuestions] = useState(1);
  const [count, setCount] = useState(5);
  const [delay, setDelay] = useState(100000000000000000000);
  const [status, setStatus] = useState('');
  const [attachmentsToHide, setAttachmentsToHide] = useState({});
  const [hasPendingVariables, setHasPendingVariables] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const query = useQueryParams();
  const isNewForm = userFormId === 'create';

  const { data, isLoading, isError, isSuccess, error } = useQuery(
    ['form', formId],
    () => fetcher(fetchForm(formId)),
    {
      onSuccess: ({ data }) => {
        setVariables(
          data?.participant.variables.filter(
            (variable) => variable.type && variable.name
          )
        );
        i18n.changeLanguage(data?.language?.toLowerCase());
        setTotalQuestions(data.questions.length || 1);
        if (isNewForm) {
          setInitialValues(
            getInitialValues(data?.questions, data?.participant)
          );
        }
      },
      refetchOnWindowFocus: false,
    }
  );

  const fetchUserFormState = useQuery(
    ['form', formId, 'user-form', userFormId],
    () => fetcher(fetchUserForm(formId, userFormId)),
    {
      enabled: !isNewForm,
      onSuccess: ({ data }) => {
        setInitialValues(data);
        setAttachmentsToHide(data.attachmentsToHide || {});
      },
      refetchOnWindowFocus: false,
    }
  );
  const { mutate: mutateAnswerForm, ...formSentPayload } = useMutation(
    (payload) => fetcher(answerForm(payload)),
    {
      onSuccess: (res) => {
        // setDelay(1000)
      },
    }
  );
  const { mutate: mutateSaveUserForm, ...formSaveUserFormState } = useMutation(
    (payload) => fetcher(saveUserForm(payload)),
    {
      onSuccess: ({ data }) => {
        // setStatus('form-sent')
        // setDelay(1000)
        if (data?._id) {
          history.replace(`/forms/${formId}/${data._id}`);
        }
      },
    }
  );

  const Schema = useMemo(() => {
    if (data) {
      return getSchema(
        data?.data?.questions,
        data?.data?.participant?.attachments,
        data?.data?.participant?.variables,
        {
          validatePhone: ['sms', 'email-sms'].includes(
            data?.data?.notificationType
          ),
        }
      );
    }
    return {};
  }, [data]);

  const formik = useFormik({
    initialValues,
    onSubmit: async (values, actions) => {
      // const {agendaProperties, variables} = Object.entries(values.variables).reduce((obj, [key, value]) => {
      //   if (key.includes('agendaProperties')) {
      //     const [,propertyName] = key.split('-')
      //     obj.agendaProperties[propertyName] = value;
      //   } else {
      //     obj.variables[key] = value;
      //   }
      //   return obj;
      // }, { agendaProperties: {}, variables: {} });
      // console.log({values})
      // mutateAnswerForm({
      //   ...values,
      //   variables,
      //    agendaProperties,
      //   externalId: query.get('externalId'),
      //   formId,
      //   userFormId
      // })
      // actions.setSubmitting(false);
    },
    enableReinitialize: true,
    validationSchema: Schema,
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [currentQuestionNumber, setCurrentQuestionNumber] = useState(1);
  const lastStep = 4;

  // console.log({v: formik.values})
  const handleQuestionChange = (questionId, answerId) => (evt) => {
    formik.setFieldValue(`questions.${questionId}`, answerId);

    const questions = data?.data?.questions;
    const currentQuestion = questions.find((q) => q._id === questionId);
    const currentAnswer = currentQuestion.answers.find(
      (a) => a._id === answerId
    );
    if (currentAnswer) {
      console.log({ currentAnswer });
      setAttachmentsToHide((old) => ({
        ...old,
        [currentQuestion._id]: currentAnswer.actions
          .filter((action) => action.element === 'attachments')
          .map((a) => a.item),
      }));
    }
  };

  const handleDateChange =
    (variableId, name = 'variables') =>
    (date) => {
      formik.setFieldValue(`${name}.${variableId}`, date);
    };

  const handleSelectChange =
    (variableId, name = 'variables') =>
    (option, action) => {
      formik.setFieldValue(`${name}.${variableId}`, option.value);
    };

  const handleSubmit = () => {
    const values = formik.values;
    const { agendaProperties, variables } = Object.entries(
      values?.variables || {}
    ).reduce(
      (obj, [key, value]) => {
        if (key.includes('agendaProperties')) {
          const [, propertyName] = key.split('-');
          obj.agendaProperties[propertyName] = value;
        } else {
          obj.variables[key] = value;
        }

        return obj;
      },
      { agendaProperties: {}, variables: {} }
    );
    mutateAnswerForm({
      ...values,
      variables: {
        ...variables,
        ...(values.pendingVariables || {}),
      },
      agendaProperties,
      externalId: query.get('externalId'),
      formId,
      userFormId,
    });
    formik.setSubmitting(false);
  };

  const saveProgress = () => {
    console.log({ save: hasPendingVariables });
    mutateSaveUserForm({
      formId,
      userFormId: isNewForm ? getMongoObjectId() : userFormId,
      attachmentsToHide,
      currentQuestionNumber,
      currentStep,
      ...formik.values,
    });
  };

  const nextStep = async () => {
    const validate = await formik.validateForm();
    const questions = data?.data?.questions;
    const questionsValues = formik.values.questions;

    if (!validate?.participant?.email && formik?.values?.participant?.email) {
      saveProgress();
    }

    console.log({ validate });

    if (currentStep === 1 && Object.keys(validate?.participant ?? {}).length) {
      formik.setErrors({
        participant: validate.participant,
      });
      formik.setTouched({
        participant: Object.fromEntries(
          Object.entries(validate?.participant || {}).map(([key, value]) => [
            key,
            true,
          ])
        ),
      });

      return;
    }

    if (currentStep === 2) {
      const currentQuestion = questions[currentQuestionNumber - 1];
      const currentAnswerId = questionsValues[currentQuestion._id];
      const currentAnswer = currentQuestion.answers.find(
        (a) => a._id === currentAnswerId
      );

      if (!currentAnswer) {
        formik.setTouched(
          {
            questions: {
              [currentQuestion._id]: true,
            },
          },
          false
        );
        formik.setErrors({
          questions: {
            [currentQuestion._id]: 'Required',
          },
        });
        return;
      }

      const variableWithErrors = {};
      if (!!currentAnswer?.variables?.length) {
        currentAnswer.variables.forEach((v) => {
          const isConstant = v.type === 'constant';
          const variableId = isConstant ? v.apiName.replace('.', '-') : v._id;
          if (validate.variables?.[variableId]) {
            variableWithErrors[variableId] = validate.variables[variableId];
          }
        });
      }

      if (
        hasPendingVariables &&
        Object.keys(validate?.pendingVariables ?? {}).length
      ) {
        formik.setTouched(
          {
            pendingVariables: Object.fromEntries(
              Object.entries(validate?.pendingVariables || {}).map(
                ([key, value]) => [key, true]
              )
            ),
          },
          false
        );
        formik.setErrors({
          pendingVariables: validate?.pendingVariables,
        });

        scroll.scrollTo(`v-${Object.keys(validate?.pendingVariables)[0]}`, {
          duration: 1500,
          delay: 100,
          smooth: 'easeInOutQuad',
          offset: 50, // Scrolls to element + 50 pixels down the page
        });

        return;
      }

      if (Object.keys(variableWithErrors ?? {}).length) {
        formik.setErrors({
          variables: variableWithErrors,
        });
        formik.setTouched({
          variables: Object.fromEntries(
            Object.entries(variableWithErrors || {}).map(([key, value]) => [
              key,
              true,
            ])
          ),
        });

        scroll.scrollTo(`v-${Object.keys(variableWithErrors)[0]}`, {
          duration: 1500,
          delay: 100,
          smooth: 'easeInOutQuad',
          offset: 50, // Scrolls to element + 50 pixels down the page
        });
        return;
      }
    }

    if (currentStep === 2 && totalQuestions !== currentQuestionNumber) {
      setCurrentQuestionNumber((currentNumber) => currentNumber + 1);
      return;
    } else if (
      currentStep === 2 &&
      totalQuestions === currentQuestionNumber &&
      !hasPendingVariables
    ) {
      const pendingVariables = data?.data?.participant?.variables;
      if (!!pendingVariables.length) {
        setHasPendingVariables(!!pendingVariables.length);
        return;
      }
    }

    if (currentStep === 3 && Object.keys(validate?.attachments ?? {}).length) {
      const pAttachemtsToHide = Object.values(attachmentsToHide).flat();
      const filteredEntries = Object.entries(
        validate?.attachments || {}
      ).filter(([key, value]) => !pAttachemtsToHide.includes(key));

      if (filteredEntries.length) {
        formik.setTouched({
          attachments: Object.fromEntries(
            filteredEntries.map(([key, value]) => [
              key,
              { url: true, name: true },
            ])
          ),
        });
        formik.setErrors({
          attachments: Object.fromEntries(filteredEntries),
        });
        scroller.scrollTo(`a-${Object.keys(validate.attachments)[0]}`);

        return;
      }
    }

    setCurrentStep((step) => step + 1);
  };

  const previousStep = () => {
    if (currentStep === 2 && currentQuestionNumber !== 1) {
      if (hasPendingVariables) {
        setHasPendingVariables(false);
        // setTotalQuestions(totalQuestions - 1)
        return;
      }
      setCurrentQuestionNumber((currentNumber) =>
        Math.max(currentNumber - 1, 1)
      );

      return;
    }

    setCurrentStep((step) => step - 1);
  };

  // useInterval(() => {
  //   if (count - 1 === 0) {
  //     window.location = formSentPayload?.data?.data?.url
  //   } else {
  //     setCount(count => count - 1)
  //   }
  // }, delay)

  const steps = useMemo(() => {
    return [
      {
        title: t('publicForms.personalInformation'),
        key: 'personalData',
        onClick: () => {
          setCurrentStep(1);
        },
      },
      {
        title: t('publicForms.generalInformation'),
        key: 'generalData',
        onClick: () => {
          setCurrentStep(2);
        },
      },
      {
        title: t('publicForms.documentation'),
        key: 'attachments',
        onClick: () => {
          setCurrentStep(3);
        },
      },
      {
        title: t('publicForms.signDocument'),
        key: 'sign',
        onClick: () => {
          setCurrentStep(4);
        },
      },
    ];
  }, [t]);

  console.log({
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    attachmentsToHide,
    totalQuestions,
    currentStep,
  });

  return (
    <PublicFormLayout
      title={data?.data?.name}
      image={data?.data?.tenantLogo}
      isLoading={
        isLoading || fetchUserFormState.isLoading || formSentPayload.isLoading
      }
      isError={isError || fetchUserFormState.isError || formSentPayload.isError}
      error={error || fetchUserFormState.error || formSentPayload.error}
      UpperComponent={
        <div className="d-flex justify-content-center">
          <div className="my-3 mt-5 d-none d-md-block" style={{ width: 480 }}>
            <Stepper
              steps={steps}
              currentStep={
                currentStep === 2
                  ? currentStep +
                    (currentQuestionNumber - 1) / data?.data?.questions?.length
                  : currentStep
              }
            />
          </div>
        </div>
      }
    >
      {/* {
            formSentPayload.isLoading && <div className="d-flex justify-content-center mt-3"><Spinner /></div> 
          } */}
      {((isNewForm && isSuccess) ||
        (!isNewForm && fetchUserFormState.isSuccess)) &&
        !formSentPayload.isLoading &&
        !formSentPayload.isSuccess && (
          <>
            {currentStep === 1 && (
              <ParticipantForm
                name="participant"
                loading={false}
                jurisdiction={data?.data?.jurisdiction}
                header={t('publicForms.personalInformation')}
                onChange={formik.handleChange}
                participant={formik?.values?.participant ?? {}}
                errors={formik.errors.participant}
                touched={formik.touched.participant}
              />
            )}
            {currentStep === 2 && !hasPendingVariables && (
              <Questionare
                questions={data?.data?.questions ?? []}
                number={currentQuestionNumber - 1}
                values={formik?.values?.questions ?? {}}
                errors={formik?.errors?.questions ?? {}}
                touched={formik?.touched?.questions ?? {}}
                formik={formik}
                onChange={handleQuestionChange}
                onDateChange={handleDateChange}
                onSelectChange={handleSelectChange}
              />
            )}
            {currentStep === 2 && !!hasPendingVariables && (
              <VariablesForm
                className="mt-2"
                name="pendingVariables"
                loading={false}
                onChange={formik.handleChange}
                variables={data?.data?.participant?.variables ?? []}
                values={formik?.values?.pendingVariables ?? {}}
                errors={formik.errors.pendingVariables}
                touched={formik.touched.pendingVariables}
                onDateChange={handleDateChange}
                onSelectChange={handleSelectChange}
              />
            )}
            {currentStep === 3 && (
              <AttachmentList
                attachments={data?.data?.participant?.attachments ?? []}
                attachmentsToHide={Object.values(attachmentsToHide).flat()}
                values={formik?.values?.attachments ?? {}}
                errors={formik?.errors?.attachments ?? {}}
                touched={formik?.touched?.attachments ?? {}}
                setFieldValue={formik.setFieldValue}
                formId={formId}
                onChange={handleQuestionChange}
                onDateChange={handleDateChange}
                onSelectChange={handleSelectChange}
              />
            )}
            {/* { currentStep === 4 && 
              <VariablesForm 
                loading={false} 
                onChange={formik.handleChange} 
                variables={variables ?? []} 
                values={formik?.values?.variables ?? {}}
                errors={formik.errors.variables}
                touched={formik.touched.variables}
                onDateChange={handleDateChange}
                onSelectChange={handleSelectChange}
              />
            } */}
            {currentStep === lastStep && (
              <div className="text-left p-4">{t('publicForms.finalStep')}</div>
            )}
            <div className="d-flex justify-content-center">
              {currentStep === 1 && (
                <Link
                  to={`/forms/${formId}`}
                  component={Button}
                  type="submit"
                  color="accent"
                  className="mr-2"
                >
                  {t('actions.cancel')}
                </Link>
              )}
              {currentStep !== 1 && (
                <Button
                  type="submit"
                  color="accent"
                  className="mr-2"
                  onClick={previousStep}
                >
                  {t('actions.previous')}
                </Button>
              )}
              {currentStep !== lastStep && (
                <Button
                  type="submit"
                  color="accent-100"
                  className="ml-2"
                  onClick={nextStep}
                  disabled={isLoading}
                >
                  {t('actions.next')}
                </Button>
              )}
              {currentStep === lastStep && (
                <Button
                  type="submit"
                  color="accent-100"
                  className="ml-2"
                  onClick={handleSubmit}
                >
                  {t('actions.send')}
                </Button>
              )}
            </div>
          </>
        )}
      {formSentPayload.isSuccess && (
        <div className="mt-4 d-flex justify-content-center flex-column align-items-center">
          <div className="p-2 mb-3 d-flex justify-content-center flex-column align-items-center">
            <Trans
              i18nKey="publicForms.formSent"
              components={{ b: <strong /> }}
              email={'test'}
              values={{ email: formik?.values?.participant?.email }}
            />
            <img
              className="mt-2"
              src={FormRecoverSent}
              alt="step1"
              style={{ height: 200, width: 300 }}
            />
          </div>
          <div className="mt-3">
            {/* <Button color="accent" >{t("actions.close")}</Button> */}
            <Button color="accent">{t('actions.resend')}</Button>
          </div>
        </div>
      )}
    </PublicFormLayout>
  );
}

export default PublicForm;

export const reactSelectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 3,
  }),
};

function AttachmentList({
  attachments,
  attachmentsToHide,
  email,
  formId,
  errors,
  values,
  touched,
  setFieldValue,
}) {
  console.log({ attachmentsToHide });
  const { t } = useTranslation();

  return (
    <Form className="row text-left">
      {attachments.length ? (
        <div className="mt-3">{t('publicForms.fillAttachments')}:</div>
      ) : (
        <div className="my-4 w-100 text-center">
          {t('publicForms.noAttachments')}
        </div>
      )}
      {attachments.map((attachment) => (
        <Element name={`a-${attachment._id}`} className="element w-100">
          <Col
            key={attachment._id}
            id={attachment._id}
            sm={12}
            className="my-3"
            hidden={attachmentsToHide.includes(attachment._id)}
          >
            <AttachmentItem
              attachment={attachment}
              formId={formId}
              email={email}
              errors={errors}
              values={values}
              touched={touched}
              setFieldValue={setFieldValue}
            />
          </Col>
        </Element>
      ))}
    </Form>
  );
}

function AttachmentItem({
  attachment,
  formId,
  email,
  errors,
  touched,
  values,
  setFieldValue,
}) {
  const { t } = useTranslation();
  const { chooseFileAndUploadFile, uploadFileState } = useFileUpload({
    isPublic: true,
    formId,
  });
  const accept = 'application/pdf,image/png,image/jpg,image/jpeg';

  const handleFileChange = (attachmentId, name) => (evt) => {
    evt.preventDefault();
    chooseFileAndUploadFile(
      {
        email,
        name,
        convertToPdf: true,
      },
      {
        accept,
        onSuccess: (data) => {
          setFieldValue(`attachments.${attachmentId}.name`, data.BaseFileName);
          setFieldValue(`attachments.${attachmentId}.url`, data.url);
        },
      }
    );
  };
  const isLink = (value = '') => {
    return value.includes('http');
  };

  const getAttachmentName = ({ name = '', url } = {}) => {
    if (!name && isLink(url)) {
      const urlArr = url.split('/');
      const aName = urlArr.pop();
      return aName;
    }

    return name;
  };

  return (
    <FormGroup className="mb-0">
      <Label className="mb-1 font-weight-bold">
        {attachment.name}
        {attachment.required && <span className="text-accent">*</span>}
      </Label>
      <div>
        <InputGroup className="w-100">
          <Input
            readOnly
            value={getAttachmentName(values[attachment._id])}
            invalid={
              errors[attachment._id]?.url && touched[attachment._id]?.url
            }
          />
          <InputGroupAddon addonType="append">
            <Button
              color="accent-100"
              size="sm"
              onClick={handleFileChange(attachment._id, attachment.name)}
            >
              {' '}
              {uploadFileState.isLoading
                ? t('actions.uploading')
                : t('actions.chooseFile')}
            </Button>
          </InputGroupAddon>
        </InputGroup>
        <small
          className="text-danger"
          hidden={!errors[attachment._id]?.url || !touched[attachment._id]?.url}
        >
          {t(`errors.${errors[attachment._id]?.url}`)}
        </small>
      </div>
    </FormGroup>
  );
}

export function Questionare({
  questions,
  name,
  onChange,
  number,
  values,
  errors,
  touched,
  hidden,
  hideVariables,
  formik,
  onDateChange,
  onSelectChange,
}) {
  const { t } = useTranslation('common');
  const prefix = name ? `${name}.` : '';

  const renderQuestion = (q, { formik, error, touch }) => {
    return (
      <Col key={q._id} sm={12} className="my-3">
        <FormGroup className="mb-0">
          <Label className="mb-1 font-weight-bold" for={`${prefix}email`}>
            {q.content} <span className="text-accent">*</span>
          </Label>
          <div>
            {q.answers.map((answer) => (
              <>
                <CustomInput
                  type="radio"
                  className="mr-2"
                  name={`questions.${q._id}`}
                  id={answer._id}
                  value={answer._id}
                  color="accent"
                  label={answer.content}
                  checked={values[q._id] === answer._id}
                  onChange={onChange(q._id, answer._id)}
                />
                <div
                  className="ml-1 font-size-12 "
                  hidden={values[q._id] !== answer._id || hideVariables}
                >
                  <VariablesForm
                    variables={answer.variables || []}
                    loading={false}
                    onChange={formik.handleChange}
                    values={formik.values?.variables ?? {}}
                    errors={formik.errors?.variables}
                    touched={formik.touched?.variables}
                    onDateChange={onDateChange}
                    onSelectChange={onSelectChange}
                  />
                </div>
                <small className="text-danger" hidden={!error || !touch}>
                  {t(`errors.Required`)}
                </small>
              </>
            ))}
          </div>
        </FormGroup>
      </Col>
    );
  };

  if (hidden) return false;

  return (
    <Form className="row text-left">
      {typeof number === 'undefined'
        ? questions.map((q) =>
            renderQuestion(q, {
              formik,
              error: errors?.[q?._id] || errors?.pop?.(),
              touch: touched?.[q?._id],
            })
          )
        : renderQuestion(questions[number], {
            formik,
            error: errors?.[questions[number]?._id] || errors?.pop?.(),
            touch: touched?.[questions[number]?._id],
          })}
    </Form>
  );
}

const DatePickerContainer = styled.div`
  width: 100%;
  .react-datepicker-wrapper,
  input {
    width: 100%;
  }
`;

function VariablesForm({
  className,
  variables,
  name = 'variables',
  onChange,
  loading,
  values,
  errors = {},
  touched = {},
  onSelectChange,
  onDateChange,
}) {
  const { t } = useTranslation('common');
  const prefix = name ? `${name}.` : '';

  const DateInput = React.forwardRef((props, ref) => (
    <input className="form-control" {...props} ref={ref} />
  ));

  return (
    <div className={clsx('row text-left', className)}>
      {/* {
        !variables?.length && 
        <div>
          No hay variables por completar
        </div>
      } */}
      {variables?.map((variable) => {
        const isConstant = variable.type === 'constant';
        const variableId = isConstant
          ? variable.apiName.replace('.', '-')
          : variable._id;

        console.log({ variable, errors, variableId, e: errors[variableId] });

        return (
          <Element name={`v-${variable._id}`} className="element w-100">
            <Col
              key={variable._id}
              id={variable._id}
              sm={12}
              className="mx-3 mb-1"
            >
              <FormGroup className="mb-0">
                <Label
                  className="mb-1 font-weight-bold text-muted"
                  for={`${prefix}email`}
                >
                  {variable.name} <span className="text-accent">*</span>
                </Label>
                <div>
                  {['fixed'].includes(variable.type) &&
                  variable?.options?.length ? (
                    <>
                      <Select
                        options={variable.options.map((opt) => ({
                          value: opt,
                          label: opt,
                        }))}
                        // isLoading={isSubmitting}
                        // isDisabled={isSubmitting}

                        styles={reactSelectStyles}
                        className="w-100"
                        onChange={onSelectChange(variableId, name)}
                        value={{
                          label: values[variableId],
                          value: values[variableId],
                        }}
                      />
                      <small className="text-danger">
                        {t(`errors.${errors[variableId]}`)}
                      </small>
                    </>
                  ) : ['date'].includes(variable.type) ? (
                    <DatePickerContainer>
                      <DatePicker
                        locale="es"
                        fullWidth
                        selected={
                          values[variableId]
                            ? new Date(values[variableId])
                            : null
                        }
                        onChange={onDateChange(variableId, name)}
                        dateFormat="dd/MM/yyyy"
                        // customInput={<DateInput />}
                        className="form-control"
                        showYearDropdown
                        showMonthDropdown
                      />
                      <small className="text-danger">
                        {t(`errors.${errors[variableId]}`)}
                      </small>
                    </DatePickerContainer>
                  ) : (
                    <InputGroup>
                      <InputWithLoader
                        type={variable.type}
                        className="form-control"
                        id={`${name}.${variableId}`}
                        name={`${name}.${variableId}`}
                        // placeholder={variable.name}
                        onChange={onChange}
                        value={values[variableId]}
                        maxLength={
                          variable.type === 'text' && variable.limit
                            ? variable.limit
                            : 10000
                        }
                        size={
                          variable.type === 'text' && variable.limit
                            ? variable.limit
                            : 10000
                        }
                        loading={loading}
                        invalid={errors[variableId] && touched[variableId]}
                      />
                      <FormFeedback>
                        {t(`errors.${errors[variableId]}`)}
                      </FormFeedback>
                    </InputGroup>
                  )}
                </div>
              </FormGroup>
            </Col>
          </Element>
        );
      })}
    </div>
  );
}

function ParticipantForm({
  header,
  loading,
  name,
  errors = {},
  touched = {},
  shieldType,
  jurisdiction,
  participant,
  onChange,
  fillMyData,
  showFillMyData,
  onFillMyData,
  onRequestAgreement,
}) {
  const { t } = useTranslation('common');
  const isFillMyDataChecked = fillMyData === name;
  const prefix = name ? `${name}.` : '';

  const cpfLabel =
    jurisdiction === 'pr'
      ? 'DNI/C.E./otro'
      : jurisdiction === 'co'
      ? 'Cédula No.'
      : 'CPF';

  return (
    <Container className="p-4">
      <h5 className={clsx({ 'text-muted': !header && !participant.label })}>
        <span className="font-weight-bold">
          {' '}
          {header || participant.label || t('forms.role')}
        </span>
      </h5>

      <Form className="row text-left">
        <Col sm={12}>
          <FormGroup>
            <Label className="mb-1 font-weight-bold" for={`${prefix}name`}>
              {t('publicForms.obligationTypeQuestion', {
                context: jurisdiction,
              })}{' '}
              <span className="text-accent">*</span>
            </Label>
            <CustomInput
              type="radio"
              className="mr-2"
              name={`participant.obligation`}
              id={'individual'}
              value={'individual'}
              color="accent"
              label={t('participant_individual', { context: jurisdiction })}
              checked={participant.obligation === 'individual'}
              onChange={onChange}
            />
            <CustomInput
              type="radio"
              className="mr-2"
              name={`participant.obligation`}
              id={'legal'}
              value={'legal'}
              color="accent"
              label={t('participant_legal', { context: jurisdiction })}
              checked={participant.obligation === 'legal'}
              onChange={onChange}
            />
          </FormGroup>
          <FormGroup className="mb-0">
            {participant.obligation === 'legal' && (
              <Label className="mb-1 font-weight-bold" for={`${prefix}name`}>
                {t('publicForms.companyName')}{' '}
                <span className="text-accent">*</span>
              </Label>
            )}
            {participant.obligation === 'individual' && (
              <Label className="mb-1 font-weight-bold" for={`${prefix}name`}>
                {t('publicForms.name')} <span className="text-accent">*</span>
              </Label>
            )}
            <InputGroup>
              <InputWithLoader
                type="text"
                className="form-control"
                id={`${prefix}name`}
                name={`${prefix}name`}
                // placeholder={t('forms.firstName')}
                onChange={onChange}
                value={participant.name}
                loading={loading}
                invalid={errors.name && touched.name}
              />
              <FormFeedback>{t(`errors.${errors.name}`)}</FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        {participant.obligation === 'individual' && (
          <Col sm={12}>
            <FormGroup className="mb-0">
              <Label
                className="mb-1 font-weight-bold"
                for={`${prefix}last_name`}
              >
                {t('publicForms.lastName')}{' '}
                <span className="text-accent">*</span>
              </Label>
              <InputGroup>
                <InputWithLoader
                  type="text"
                  className="form-control"
                  id={`${prefix}last_name`}
                  name={`${prefix}last_name`}
                  // placeholder={t('forms.lastName')}
                  onChange={onChange}
                  value={participant.last_name}
                  loading={loading}
                  invalid={errors.last_name && touched.last_name}
                />
                <FormFeedback>{t(`errors.${errors.last_name}`)}</FormFeedback>
              </InputGroup>
            </FormGroup>
          </Col>
        )}
        {participant.obligation === 'legal' && (
          <Col sm={12}>
            <FormGroup className="mb-0">
              <Label
                className="mb-1 font-weight-bold"
                for={`${prefix}representative`}
              >
                {t('publicForms.representative')}{' '}
                <span className="text-accent">*</span>
              </Label>
              <InputGroup>
                <InputWithLoader
                  type="text"
                  className="form-control"
                  id={`${prefix}representative`}
                  name={`${prefix}representative`}
                  // placeholder={t('forms.representative')}
                  onChange={onChange}
                  value={participant.representative}
                  loading={loading}
                  invalid={errors.representative && touched.representative}
                />
                <FormFeedback>
                  {t(`errors.${errors.representative}`)}
                </FormFeedback>
              </InputGroup>
            </FormGroup>
          </Col>
        )}
        <Col sm={12} className="my-3">
          <FormGroup className="mb-0">
            <Label className="mb-1 font-weight-bold" for={`${prefix}email`}>
              {t('publicForms.email', { context: participant.obligation })}{' '}
              <span className="text-accent">*</span>
            </Label>
            <InputGroup>
              <InputWithLoader
                type="email"
                className="form-control"
                id={`${prefix}email`}
                name={`${prefix}email`}
                // placeholder={t('forms.email')}
                onChange={onChange}
                value={participant.email}
                loading={loading}
                invalid={errors.email && touched.email}
              />
              <FormFeedback>{t(`errors.${errors.email}`)}</FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col sm={12}>
          <FormGroup className="form-group mb-0">
            <Label className="mb-1 font-weight-bold" for={`${prefix}phone`}>
              {t('publicForms.phone', { context: participant.obligation })}{' '}
              <span className="text-accent">*</span>
            </Label>
            <InputGroup>
              {/* <PhoneNumberInput
                    className="form-control" 
                    id={`${prefix}phone`} 
                    name={`${prefix}phone`}
                    // placeholder={t('forms.phoneNumber')}
                    onChange={onChange}  
                    value={participant.phone}
                    loading={loading}
                    invalid={errors.phone && touched.phone}
                  /> */}
              <InputWithLoader
                type="text"
                className="form-control"
                id={`${prefix}phone`}
                name={`${prefix}phone`}
                // placeholder={t('forms.phoneNumber')}
                onChange={onChange}
                value={participant.phone}
                loading={loading}
                invalid={errors.phone && touched.phone}
              />
              <FormFeedback>{t(`errors.${errors.phone}`)}</FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col sm={12} hidden={!['br'].includes(jurisdiction)}>
          <FormGroup className="mb-0">
            <Label className="mb-1 font-weight-bold" for={`${prefix}cargo`}>
              {t('Cargo')} <span className="text-accent">*</span>
            </Label>
            <InputGroup>
              <InputWithLoader
                type="text"
                className="form-control"
                id={`${prefix}cargo`}
                name={`${prefix}cargo`}
                // placeholder={t('forms.lastName')}
                onChange={onChange}
                value={participant.cargo}
                loading={loading}
                invalid={errors.cargo && touched.cargo}
              />
              <FormFeedback>{t(`errors.${errors.cargo}`)}</FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col sm={12} hidden={!['br'].includes(jurisdiction)}>
          <FormGroup className="mb-0">
            <Label className="mb-1 font-weight-bold" for={`${prefix}rg`}>
              {t('RG')} <span className="text-accent">*</span>
            </Label>
            <InputGroup>
              <InputWithLoader
                type="text"
                className="form-control"
                id={`${prefix}rg`}
                name={`${prefix}rg`}
                // placeholder={t('forms.lastName')}
                onChange={onChange}
                value={participant.rg}
                loading={loading}
                invalid={errors.rg && touched.rg}
              />
              <FormFeedback>{t(`errors.${errors.rg}`)}</FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col sm={12} hidden={!['br', 'co', 'pr'].includes(jurisdiction)}>
          <FormGroup className="mb-0">
            <Label className="mb-1 font-weight-bold" for={`${prefix}cpf`}>
              {t(cpfLabel)} <span className="text-accent">*</span>
            </Label>
            <InputGroup>
              <InputWithLoader
                type="text"
                className="form-control"
                id={`${prefix}cpf`}
                name={`${prefix}cpf`}
                // placeholder={t('forms.lastName')}
                onChange={onChange}
                value={participant.cpf}
                loading={loading}
                invalid={errors.cpf && touched.cpf}
              />
              <FormFeedback>{t(`errors.${errors.cpf}`)}</FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
      </Form>
    </Container>
  );
}
